import { JustizversagenEntry } from '../model/justizversagen';
import { DataFetcher } from './fetcher/DataFetcher';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface JustizversagenSearchParams extends AbstractSearchParams {
  country?: string;
  failure_type?: string;
  case_status?: string;
  event_date?: string;
  date_from?: string;
  date_to?: string;
  title?: string;
}

export class JustizversagenRepository extends RepositoryNocoDbBase<JustizversagenEntry, JustizversagenSearchParams> {
  protected readonly TABLE_NAME = 'justizversagen';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD = 'event_date' as const;

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS = ['country', 'failure_type', 'case_status'];

  protected readonly EQUAL_FILTERS = ['country', 'failure_type', 'case_status'];

  protected readonly SEARCH_FIELDS: (keyof JustizversagenEntry)[] = [
    'title',
    'subject',
    'what_happened',
    'authority',
    'region',
    'failure_type',
    'case_status'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
